import { Alert } from "@mui/material";
import { toJalaliDate } from "../../../utils/date";
import { useFetchPrivateGateWayNumberQuery } from "../api-hooks/smsCampaignQuery";

export default function SmsCampaignPrivateGatewayNumberAlert() {
    const { data } = useFetchPrivateGateWayNumberQuery();

    if (!data || !data.hasAccessToPrivateGatewayNumbers) {
        return <></>;
    }

    return (
        <Alert variant="filled" sx={{ mt: 2 }}>
            دسترسی شما به سرشماره های خدماتی تا تاریخ &nbsp;
            {toJalaliDate(data.privateGatewayNumbersExpirationDate)}&nbsp; فعال
            خواهد بود.
        </Alert>
    );
}
